import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const defaultCertification = {
	name: '',
	description: '',
}

export default function CertificationForm({ initialData, onSubmit, onCancel, submitting = false, mode = 'add' }) {
	const { t } = useTranslation()
	const [form, setForm] = useState(defaultCertification)

	useEffect(() => {
		setForm({
			...defaultCertification,
			...(initialData || {}),
		})
	}, [initialData])

	const isEditMode = mode === 'edit'
	const submitLabel = isEditMode ? t('trainingCertifications.edit.actions.submit') : t('trainingCertifications.add.actions.submit')
	const submittingLabel = isEditMode ? t('trainingCertifications.edit.actions.submitting') : t('trainingCertifications.add.actions.submitting')

	const handleChange = (field, value) => {
		setForm(prev => ({
			...prev,
			[field]: value,
		}))
	}

	const handleSubmit = event => {
		event.preventDefault()
		onSubmit({
			name: `${form.name || ''}`.trim(),
			description: `${form.description || ''}`.trim(),
		})
	}

	return (
		<form className="space-y-6" onSubmit={handleSubmit}>
			<div className="grid grid-cols-1 gap-4">
				<label className="flex flex-col gap-1">
					<span className="text-sm font-medium text-gray-700">{t('trainingCertifications.form.fields.name')} *</span>
					<input
						type="text"
						value={form.name || ''}
						onChange={event => handleChange('name', event.target.value)}
						placeholder={t('trainingCertifications.form.placeholders.name')}
						className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
						required
					/>
				</label>

				<label className="flex flex-col gap-1">
					<span className="text-sm font-medium text-gray-700">{t('trainingCertifications.form.fields.description')}</span>
					<textarea
						rows={5}
						value={form.description || ''}
						onChange={event => handleChange('description', event.target.value)}
						placeholder={t('trainingCertifications.form.placeholders.description')}
						className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
					/>
				</label>
			</div>

			<div className="flex justify-end gap-3 border-t border-gray-200 pt-4">
				<button
					type="submit"
					disabled={submitting}
					className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
				>
					{submitting ? submittingLabel : submitLabel}
				</button>
				{onCancel ? (
					<button
						type="button"
						onClick={onCancel}
						className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50"
					>
						{t('trainingCertifications.form.actions.cancel')}
					</button>
				) : null}
			</div>
		</form>
	)
}
